<template>
  <div id="my-report">
    <div class="container">
      <div class="contents">
        <div
          class="character"
          :style="{ backgroundImage: `url(${userCharacterImgURL})` }"
        ></div>
        <div class="type">{{ userType }}</div>
        <p>
          {{ summaryReport }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
import ReportService from '@/services/report-service'

export default {
  name: 'ReportShare',
  mixins: [common],
  data() {
    return {
      pageTitle: 'My Report',

      userCharacterImgURL: null,
      userType: '',
      summaryReport: ''
    }
  },
  created() {
    this.$parent.setNav(false)
    this.$parent.setHeader(this.pageTitle)
    this.$parent.setBottomTab(false)

    const shareCode = this.$route.params.code
    if (this.isEmpty(shareCode)) {
      this.goBack()
    } else {
      this.performGetReport(shareCode)
    }
  },
  methods: {
    performGetReport(code) {
      ReportService.getShareReport(code).then(({ resultCode, resultData }) => {
        if (resultCode === 0 && !this.isEmpty(resultData)) {
          this.userCharacterImgURL = `${process.env.VUE_APP_API_BASE_URL}${resultData.image}`
          this.userType = resultData.type
          this.summaryReport = resultData.overview
        }
      })
    }
  }
}
</script>

<style lang="scss" src="@/scss/my-report.scss" scoped></style>
